class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverDesktopMq = window.matchMedia('(min-width: 990px)');
    this.closeTimer = null;
    this.hoverDelay = 150;
    this.pendingNestedTimers = new Map();
    this.boundMouseEnter = this.onHeaderMenuMouseEnter.bind(this);
    this.boundMouseLeave = this.onHeaderMenuMouseLeave.bind(this);
    this.boundSummaryClick = this.onSummaryPointerClick.bind(this);
    this._nestedHoverCleanup = [];

    this.setupDesktopHover();
  }

  setupDesktopHover() {
    this.addEventListener('mouseenter', this.boundMouseEnter);
    this.addEventListener('mouseleave', this.boundMouseLeave);

    this.querySelectorAll('summary').forEach((summary) => {
      summary.addEventListener('click', this.boundSummaryClick);
    });

    this.querySelectorAll('.header__submenu > li').forEach((li) => {
      const nested = li.querySelector(':scope > details');
      if (!nested) return;

      const onEnter = () => {
        const pending = this.pendingNestedTimers.get(li);
        if (pending) clearTimeout(pending);
        this.pendingNestedTimers.delete(li);
        if (!this.hoverDesktopMq.matches) return;
        nested.setAttribute('open', '');
        const s = nested.querySelector('summary');
        if (s) s.setAttribute('aria-expanded', 'true');
      };

      const onLeave = () => {
        if (!this.hoverDesktopMq.matches) return;
        const t = setTimeout(() => {
          nested.removeAttribute('open');
          const s = nested.querySelector('summary');
          if (s) s.setAttribute('aria-expanded', 'false');
          this.pendingNestedTimers.delete(li);
        }, this.hoverDelay);
        this.pendingNestedTimers.set(li, t);
      };

      li.addEventListener('mouseenter', onEnter);
      li.addEventListener('mouseleave', onLeave);
      this._nestedHoverCleanup.push(() => {
        li.removeEventListener('mouseenter', onEnter);
        li.removeEventListener('mouseleave', onLeave);
      });
    });
  }

  onHeaderMenuMouseEnter() {
    clearTimeout(this.closeTimer);
    if (!this.hoverDesktopMq.matches) return;
    this.mainDetailsToggle.setAttribute('open', '');
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');
  }

  onHeaderMenuMouseLeave() {
    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => {
      if (!this.hoverDesktopMq.matches) return;
      this.close();
      this.querySelectorAll('.header__submenu details[open]').forEach((d) => {
        d.removeAttribute('open');
        const s = d.querySelector('summary');
        if (s) s.setAttribute('aria-expanded', 'false');
      });
    }, this.hoverDelay);
  }

  onSummaryPointerClick(e) {
    if (!this.hoverDesktopMq.matches) return;
    if (e.pointerType === 'mouse' || e.pointerType === 'pen') {
      e.preventDefault();
    }
  }

  disconnectedCallback() {
    this.removeEventListener('mouseenter', this.boundMouseEnter);
    this.removeEventListener('mouseleave', this.boundMouseLeave);
    this.querySelectorAll('summary').forEach((summary) => {
      summary.removeEventListener('click', this.boundSummaryClick);
    });
    this._nestedHoverCleanup.forEach((fn) => fn());
    clearTimeout(this.closeTimer);
    this.pendingNestedTimers.forEach((t) => clearTimeout(t));
    this.pendingNestedTimers.clear();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
